import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FormEvalFactorServices from "./eval_form_factor.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getFormEvalFactor = filters => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_FORMULARIO_FACTOR,
      payload: true,
    });
    const resp = await FormEvalFactorServices.getFormEvalFactors(filters);
    dispatch({
      type: actions.GET_FORMULARIO_FACTOR,
      payload: {
        evalFormFactor:resp.data.factores,
        evalFormFactorState:resp.data.estado_evaluacion,
        nota: resp.data.nota_factor,
        desempeño: resp.data.categoria_desempenio?resp.data.categoria_desempenio:""
      },
    });
    dispatch({
      type: actions.FORMULARIO_FACTOR_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORMULARIO_FACTOR_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_FORMULARIO_FACTOR,
      payload: false,
    });
  }
}

export const getFormEvalCompeteciaById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_FORMULARIO_FACTOR,
      payload: true,
    });
    const resp = await FormEvalFactorServices.getFormEvalFactor(id);

    console.log('Data preguntas => ', resp);

    dispatch({
      type: actions.GET_FORMULARIO_FACTOR,
      payload: resp.data,
    });
    dispatch({
      type: actions.FORMULARIO_FACTOR_FALLA,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORMULARIO_FACTOR_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_FORMULARIO_FACTOR,
      payload: false,
    });
  }
};

export const saveFormEvalFactor = (req, setShowModal) => async (dispatch, getState) => {
  try {

    dispatch({
      type: actions.SAVE_LOADER_FORMULARIO_FACTOR,
      payload: true,
    });
    const resp = await FormEvalFactorServices.saveFormEvalFactor(req);
    const { data, count } = getState().formEvalFactor.formEvalFactor;
    dispatch({
      type: actions.GET_FORMULARIO_FACTOR,
      payload: {
        count: count + 1,
        data: [...data, resp.data]
      },
    });
    dispatch({
      type: actions.FORM_FORMULARIO_FACTOR_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FORMULARIO_FACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_FORMULARIO_FACTOR,
      payload: false,
    });
  }
};

export const editFormEvalFactor = (id, req) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_FORMULARIO_FACTOR,
      payload: true,
    });
    const resp = await FormEvalFactorServices.editFormEvalFactor(id, req);
    const { evalFormFactorState } = getState().evalFormFactor;
     dispatch({
      type: actions.GET_FORMULARIO_FACTOR,
      payload: {
        evalFormFactor:resp.data.factores,
        evalFormFactorState: evalFormFactorState,
        nota: resp.data.nota_factor,
        desempeño: resp.data.categoria_desempenio?resp.data.categoria_desempenio:""
      },
    });
    dispatch({
      type: actions.FORM_FORMULARIO_FACTOR_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORMULARIO_FACTOR_FALLA,
      payload: message
    })
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_FORMULARIO_FACTOR,
      payload: false,
    });
  }
}

export const deleteFormEvalFactor = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_FORMULARIO_FACTOR,
      payload: true,
    });
    await FormEvalFactorServices.deleteFormEvalFactor(id);
    const { data, count } = getState().formEvalFactor.formEvalFactor;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_FORMULARIO_FACTOR,
      payload: {
        data: _data,
        count: count - 1
      },
    });
    dispatch({
      type: actions.FORMULARIO_FACTOR_FALLA,
      payload: '',
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORMULARIO_FACTOR_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_FORMULARIO_FACTOR,
      payload: false,
    });
  }
}

